import React from 'react'
import { Tag, Tooltip } from 'antd'

const status = [
  { key: "Whale", name: "Whale", color: "purple", title: "Make usage more than RM1000 in the last 7 days" },
  { key: "Rising Star", name: "Rising Star", color: "yellow", title: "Registered last 7 days and Usage more than RM500" },
  {
    key: "Risky",
    name: "Risky",
    color: "red",
    title: "User that have topup value/order count in the current week is 20% lower compared to the same week in the previous month. Example: Compare Week 2 of this month to Week 2 of last month."
  },
  { key: "Risky Whale", name: "Risky Whale", color: "blue", title: "This user was previously a Whale, but their activity has dropped by 20% or more compared to last month. They are now flagged as a Risky Whale" },
];

const UserBadgeTag = ({ statusKey }) => {

  const theStatus = status.find(theStatus => theStatus.key === statusKey)
  if (theStatus) {
    return (
      <React.Fragment>
        <Tooltip placement="topLeft" title={theStatus.title}>
          <Tag color={theStatus.color}>{theStatus.name}</Tag>
        </Tooltip>
      </React.Fragment>
    )
  }
  return null
}

export default UserBadgeTag